import { Box, Button, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import * as React from 'react';
import IconButtonTitle from '../../../../common/component/IconButtonTitle';
import TableCustom, { Columns } from '../../../../common/component/TableCustom';
import MediCard from 'modules/common/component/MediCard';
import { some } from '../../../../common/constants';
import { NumericFormatText } from 'modules/common/utils';
import { FormattedMessage } from 'react-intl';

interface Props {
  data?: some;
  setFormData: (item: some) => void;
  setFormDataGroup: (item: some) => void;
  onDelete: (item: some) => void;
  onDeleteGroup: (item: some) => void;
  loading?: boolean;
  enableDeleteGroup?: boolean;
}

const ServiceCSVTable: React.FunctionComponent<Props> = (props) => {
  const { data, setFormData, setFormDataGroup, onDelete, onDeleteGroup, enableDeleteGroup, loading } = props;

  const columns = React.useMemo(() => {
    return [
      {
        title: 'serviceCode',
        dataIndex: 'code',
        width: 100,
      },
      {
        title: 'serviceName',
        dataIndex: 'name',
        render: (record) => <Typography color={record?.name?.length > 255 ? 'red' : ''}>{record?.name}</Typography>,
        width: '15%',
      },
      {
        title: 'departmentCode',
        dataIndex: 'specializedDepartmentId',
        width: '15%',
      },
      {
        title: 'service.room',
        dataIndex: 'physicsRoomId',
        width: '15%',
      },
      {
        title: 'price',
        align: 'right',
        dataIndex: 'price',
        width: '15%',
        render: (record) => record.price && NumericFormatText(record.price),
      },
      {
        title: 'action',
        align: 'right',
        width: 120,
        render: (record) => {
          const { specializedDepartment = {}, physicsRoom = {} } = record;
          return (
            <>
              <IconButtonTitle
                title="update"
                size="small"
                onClick={() => {
                  setFormData({
                    ...record,
                    systemCategoryId: data?.id,
                    department: specializedDepartment.id,
                    room: { value: physicsRoom.id, label: physicsRoom.name },
                  });
                }}
                style={{ margin: '0px 8px' }}
              >
                <EditIcon color={record.validation === false ? 'error' : undefined} />
              </IconButtonTitle>
              <IconButtonTitle
                title="delete"
                size="small"
                onClick={() => {
                  onDelete({ ...record });
                }}
              >
                <DeleteIcon />
              </IconButtonTitle>
            </>
          );
        },
      },
    ] as Columns[];
  }, [setFormData, data?.id, onDelete]);

  if (!data) {
    return null;
  }

  return (
    <MediCard
      style={{ margin: '8px 0px', color: 'white' }}
      title={
        <Box display="flex" alignItems="center">
          <Box flex={1}>
            <Typography variant="subtitle1" color="inherit">
              {data.name}
            </Typography>
          </Box>
          <Box display="flex">
            <IconButtonTitle
              title="create"
              size="small"
              color="inherit"
              onClick={() => setFormData({ systemCategoryId: data.id })}
            >
              <NoteAddIcon />
            </IconButtonTitle>
            <IconButtonTitle
              title="update"
              size="small"
              color="inherit"
              onClick={() => setFormDataGroup(data)}
              style={{ margin: '0px 8px' }}
            >
              <EditIcon />
            </IconButtonTitle>
            <IconButtonTitle
              title="delete"
              size="small"
              color="inherit"
              disabled={!!data.services?.length && !enableDeleteGroup}
              onClick={() => {
                onDeleteGroup(data);
              }}
            >
              <DeleteIcon />
            </IconButtonTitle>
          </Box>
        </Box>
      }
    >
      <Box padding={1}>
        <TableCustom
          dataSource={data?.services}
          loading={loading}
          columns={columns}
          caption={
            <Button
              size="large"
              fullWidth
              variant="text"
              startIcon={<NoteAddIcon />}
              color="primary"
              onClick={() => setFormData({ systemCategoryId: data.id })}
            >
              <Typography variant="subtitle2">
                <FormattedMessage id="service.addNewInList" />
              </Typography>
            </Button>
          }
        />
      </Box>
    </MediCard>
  );
};

export default ServiceCSVTable;
